// extracted by mini-css-extract-plugin
module.exports = {"editorCanvasBorder":"#6A6A6A"};